export default __webpack_public_path__ + "static/media/meatloaf.102efbd7.jpg";